import './Tooltip.css';

import type { FunctionComponent, PropsWithChildren } from 'react';

type TooltipProps = PropsWithChildren<{
  title: string;
  content: string;
}>;

export const Tooltip: FunctionComponent<TooltipProps> = ({
  children,
  title,
  content,
}) => {
  return (
    <div className="tooltip-trigger">
      {children}
      <div className="tooltip">
        <p className="text-xs semibold tooltip-title">{title}</p>
        <p className="text-xs regular tooltip-content">{content}</p>
        <div className="tooltip-arrow" />
      </div>
    </div>
  );
};
